import { render, staticRenderFns } from "./Contribute.vue?vue&type=template&id=e9489a08&scoped=true"
import script from "./Contribute.vue?vue&type=script&lang=js"
export * from "./Contribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9489a08",
  null
  
)

export default component.exports